import store from 'app/store';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: ['admin', 'sub-admin', 'producer', 'sub-producer'],
    routes: [
        {
            path: '/monthly-reports',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./AdminMonthlyReportsApp');
                        case 'producer':
                        case 'sub-producer':
                            return import('./ProducerMonthlyReportsApp');
                        default:
                            break;
                    }
                },
            }),
        },
    ],
};

export default [Index];
